<template>
  <div class="img-upload-wrapper" v-infinite-scroll="load" :infinite-scroll-delay="500" :infinite-scroll-distance="1000">
    <div class=" sticky-top pb-3 bg-white">
      <el-select
        v-model="category"
        placeholder="请选择"
        size="small"
        class="w-100"
        @change="claerPage"
      >
        <el-option
          v-for="item in typeList"
          :key="item.id"
          :label="item.title"
          :value="item.id"
        >
        </el-option>
      </el-select>
    </div>
    <el-row :gutter="20" class="m-0">
      <!-- 图片列表 -->
      <el-col
        :span="6"
        v-for="(img, index) in imgList"
        :key="img.index"
        class="img-min p-1"
      >
        <div class="grid-content bg-purple sel-img">
          <span v-if="isSel(img) !== ''">{{ isSel(img) + 1 }}</span>
          <el-image
            style="width: 100%; height: 100%"
            :src="img.url + '?x-oss-process=style/small-2x'"
            fit="cover"
            :lazy="true"
            @click="onSelectImg(img)"
          >
          </el-image>
        </div>
        <div class="title">
          <div
            v-if="!img.is_edit"
            @click="onEditTitle(img, index)"
            class="font-line-2 text-center w-100"
          >
            {{ img.name }}
          </div>
          <el-input
            placeholder="请输入标题"
            v-model="img.name"
            @change="onEditTitle(img, index)"
            v-else
            size="mini"
          >
            <el-button
              slot="append"
              icon="el-icon-check"
              size="mini"
              @click.stop="onEditTitle(img, index)"
            ></el-button>
          </el-input>
        </div>
      </el-col>
    </el-row>
    <div class=" text-center w-100 mb-5" v-if="is_load"><i class="el-icon-loading text-danger fs-2"></i></div>
    <div class=" text-center w-100 mb-5 text-muted" v-if="is_end">没有更多了...</div>
    <!-- 大图预览 -->
    <el-dialog :visible="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>
<script>
import MaterialDepositoryService from "@/service/MaterialDepository.service.js";
export default {
  components: {},
  props: {
    maxLength: {
      type: Number,
      default: 1000,
    },
  },
  data() {
    return {
      imgList: [],
      dialogVisible: false,
      dialogImageUrl: "",
      selImgList: [],
      page: 1,
      total: 0,
      is_load: false,
      is_end: false,
      typeList: [],
      category: -1
    };
  },
  methods: {
    onEditTitle(imgData, index) {
      if (imgData.name === "") {
        this.$notify({
          title: "提示",
          message: "图片名称不得为空！",
        });
        return;
      }
      imgData.is_edit ? (imgData.is_edit = false) : (imgData.is_edit = true);
    },
    onSelectImg(item) {
      if (this.isSel(item) === "") {
        if (this.selImgList.length < this.maxLength) {
          this.selImgList.push(item);
        } else {
          this.$notify({
            title: "提示",
            message: `最多只可选择${this.maxLength}张图片`,
            type: "warning",
          });
        }
      } else {
        this.selImgList.splice(this.isSel(item), 1);
      }
      this.$emit("OnImgChange", this.selImgList);
    },
    isSel(item) {
      return this.selImgList.indexOf(item) == -1
        ? ""
        : this.selImgList.indexOf(item);
    },
    onEditTitle(imgData, index) {
      this.imgList.forEach((item) => {
        if (item.uid !== imgData.uid) item.is_edit = false;
      });
      if (imgData.name === "") {
        this.$notify({
          title: "提示",
          message: "图片名称不得为空！",
        });
        return;
      }
      imgData.is_edit ? (imgData.is_edit = false) : (imgData.is_edit = true);
      imgData.percentage = imgData.percentage++;
      this.$emit("OnImgChange", this.imgList);
    },
    clearList() {
      this.selImgList = [];
    },
    claerPage () {
      this.page = 1
      this.imgList = []
      this.init()
    },
    init () {
      this.is_load = true
      MaterialDepositoryService.getList({size: 16, page: this.page, category: this.category}).then((res) => {
        const imgList = res.results.map((item) => {
          item.url = item.url;
          item.response_url = item.url;
          item.name = item.title;
          item.is_edit = false;
          return item;
        });
        this.total = res.count
        this.imgList.push(...imgList)
        this.is_load = false
      });
    },
    load () {
      if (this.total / 20 > this.page) {
        this.page++
        this.init()
      } else {
        this.is_end = true
      }
    },
  },
  mounted() {
    this.init()
    MaterialDepositoryService.getTypeList({ size: 1000 }).then((res) => {
      this.typeList = res.results;
    });
  },
};
</script>
<style  scoped>
.img-upload-wrapper {
  text-align: left;
  position: absolute;
  min-height: 50px;
  width: 100%;
  top: 80px;
  bottom: 40px;
  overflow-y: scroll;
  overflow-x: hidden;
}
.img-min {
  margin-bottom: 5px;
  cursor: pointer;
}
.img-min .title {
  margin-top: 5px;
  height: 30px;
  display: flex;
  align-items: center;
  font-size: 14px;
}
.img-min .title p {
  text-overflow: ellipsis;
  overflow: hidden;
  font-size: 14px;
}
.img-min .title .el-input__inner {
  padding: 0 5px !important;
}
.img-min .progress {
  width: 100%;
  height: 100%;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(34, 34, 34, 0.2);
}
.img-min .grid-content,
.img-min .upload {
  width: 100%;
  height: 0;
  padding-bottom: 100%;
  border-radius: 6px;
  overflow: hidden;
  position: relative;
}

.img-min .grid-content .el-image {
  height: 100%;
  position: absolute;
}
.sel-img {
  position: relative;
}
.sel-img span {
  width: 20px;
  height: 20px;
  position: absolute;
  z-index: 22;
  background: #f56c6c;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  right: 5px;
  top: 5px;
  font-size: 12px;
  font-weight: bold;
}
</style>